import type { UtilityContext } from '@change-corgi/core/react/utilityContext';

import { NotFoundError } from 'src/shared/error';

import type { PaginatedContextData, PaginatedData } from 'src/app/shared/contexts/asyncData';

import { DecisionMakerTargetedPetitions } from './api.graphql';
import type { DecisionMakerTargetedPetitionsQuery, DecisionMakerTargetedPetitionsQueryVariables } from './api.graphql';
import type { DecisionMakerTargetedPetitionsItem } from './types';

type DecisionMakerTargetedPetitionsApiData = PaginatedData<
	DecisionMakerTargetedPetitionsItem,
	{
		totalCount: number;
	}
>;

export type DecisionMakerTargetedPetitionsData = PaginatedContextData<DecisionMakerTargetedPetitionsApiData>;

async function getData({
	utilityContext,
	slug,
	cursor,
	numPetitionsToFetch,
}: {
	utilityContext: UtilityContext;
	slug: string;
	cursor?: string;
	numPetitionsToFetch?: number;
}): Promise<DecisionMakerTargetedPetitionsApiData> {
	const {
		gql: { fetch },
	} = utilityContext;

	const { data } = await fetch<DecisionMakerTargetedPetitionsQuery, DecisionMakerTargetedPetitionsQueryVariables>({
		query: DecisionMakerTargetedPetitions,
		variables: { cursor: cursor ?? null, slug, numPetitionsToFetch: numPetitionsToFetch || 10 },
		rejectOnError: true,
	});

	if (!data.decisionMaker) throw new NotFoundError();

	return {
		items: data.decisionMaker.targetedPetitionsConnection.nodes,
		cursor: data.decisionMaker.targetedPetitionsConnection.pageInfo.endCursor,
		hasNextPage: data.decisionMaker.targetedPetitionsConnection.pageInfo.hasNextPage,
		totalCount: data.decisionMaker.targetedPetitionsConnection.totalCount,
	};
}

export async function getFirstPageData(utilityContext: UtilityContext, slug: string) {
	return getData({ utilityContext, slug, numPetitionsToFetch: 4 });
}

export async function getNextPageData(utilityContext: UtilityContext, cursor: string, slug: string) {
	return getData({ utilityContext, slug, cursor });
}
